module.exports = __webpack_public_path__ + "static/bot4-27f62d106eb34f4cb7966f389904a3f6.jpg";